import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { WalletSearchResultDto } from 'api/Search/Types/SearchResultDto'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

export const WalletColumnDefinition: GridColumnProps[] = [
  {
    title: 'Name',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as WalletSearchResultDto
      if (!data.value) {
        return <td />
      }
      if (!data.id) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsWallets.detailsUrl as string, {
                id: data.id,
                slug: 'details',
              }),
            }}
          >
            {data.value}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Client',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as WalletSearchResultDto
      if (!data.value) {
        return <td />
      }
      if (!data.id) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsClients.detailsUrl as string, {
                id: data.data.client.id,
                slug: 'details',
              }),
            }}
          >
            {data.data.client.name}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Type',
    field: 'data.walletType.name',
  },
  {
    title: 'State',
    field: 'data.walletState.name',
  },
  {
    title: 'Entity',
    cell: (props: GridCellProps): JSX.Element => {
      const dataItem = props.dataItem as WalletSearchResultDto
      if (!dataItem.data?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td>
          <CompanyTag id={dataItem.data.tickmillCompany.id}>
            {dataItem.data.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    width: 80,
    minResizableWidth: 80,
  },
]
